
import { useState, useEffect } from "react";
import { useLanguage } from "../../../hooks/useLanguage";

export default function ColombianPaymentsBanner() {
  const { t } = useLanguage();

  const paymentMethods = [
    {
      name: "Nequi",
      description: t('colombian.nequi_desc'),
      color: "#FF006B",
      logo: "https://static.readdy.ai/image/18682db60553df15ba50b947d4252b50/9bbb0ea2fd6a8b625dfa0d1af5ad1fa4.png",
    },
    {
      name: "Daviplata",
      description: t('colombian.daviplata_desc'),
      color: "#E30613",
      logo: "https://static.readdy.ai/image/18682db60553df15ba50b947d4252b50/4738bf97cbdee510c76b19003d71dd2e.png",
    },
    {
      name: "Efecty",
      description: t('colombian.efecty_desc'),
      color: "#FFD700",
      logo: "https://static.readdy.ai/image/18682db60553df15ba50b947d4252b50/056c5be3003cf61f3b6a652d0e578a82.png",
    },
    {
      name: "Bancolombia",
      description: t('colombian.bancolombia_desc'),
      color: "#FFDD00",
      logo: "https://static.readdy.ai/image/18682db60553df15ba50b947d4252b50/ac30a729568787a58fc2795433e34521.png",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % paymentMethods.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Defensive: ensure paymentMethods is not empty to avoid division by zero
  if (!paymentMethods.length) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-purple-50 rounded-2xl p-6 sm:p-8 border border-blue-100 shadow-sm">
      <div className="flex flex-col items-center text-center">
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-3 shadow-md">
            <i className="ri-flag-fill"></i>
            <span>{t('colombian.title')}</span>
          </div>
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            {t('colombian.heading')} 🇨🇴
          </h3>
          <p className="text-gray-600 text-sm sm:text-base">
            {t('colombian.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 w-full max-w-3xl">
          {paymentMethods.map((method, idx) => (
            <div
              key={method.name}
              className={`
                relative bg-white rounded-xl p-4 sm:p-6 border-2 transition-all duration-500 cursor-pointer
                ${activeIndex === idx ? 'border-opacity-100 scale-105 shadow-lg' : 'border-transparent bg-white/60 scale-100'}
              `}
              style={{
                borderColor: activeIndex === idx ? `${method.color}40` : 'transparent',
                boxShadow: activeIndex === idx ? `0 4px 15px ${method.color}15` : 'none',
                transform: activeIndex === idx ? 'scale(1.05)' : 'scale(1)',
              }}
            >
              <div
                className={`w-7 h-7 sm:w-9 sm:h-9 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-500 ${activeIndex === idx ? 'shadow-sm' : ''}`}
                style={{ backgroundColor: activeIndex === idx ? `${method.color}15` : '#f3f4f6' }}
              >
                <img src={method.logo} alt={method.name} className="w-5 h-5 sm:w-6 sm:h-6 object-contain" />
              </div>
              <h4 className="text-xs sm:text-sm font-bold text-gray-900 mt-3 mb-1">{method.name}</h4>
              <p className="text-[10px] sm:text-xs text-gray-600 leading-tight">{method.description}</p>
              {activeIndex === idx && (
                <div className="absolute -top-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full flex items-center justify-center shadow-md animate-bounce" style={{ backgroundColor: method.color }}>
                  <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-2 text-sm text-gray-600">
          <i className="ri-shield-check-fill text-green-600"></i>
          <span>{t('colombian.secure')}</span>
        </div>
      </div>
    </div>
  );
}
